__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-spa/phx-rel-R24.12.2_12062410AM/_next/";